import Vue from "vue";

import PhysicalPurchasesList from "./PhysicalPurchasesList.vue";

export function load() {
    const selector = "physical-purchases-list";

  // Is the custom Vue root element in the DOM?
  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(PhysicalPurchasesList, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}
